import { useRef, useEffect } from 'react';

var useUnmountedRef = function useUnmountedRef() {
  var unmountedRef = useRef(false);
  useEffect(function () {
    unmountedRef.current = false;
    return function () {
      unmountedRef.current = true;
    };
  }, []);
  return unmountedRef;
};

export default useUnmountedRef;


//////////////////
// WEBPACK FOOTER
// ./~/ahooks/es/useUnmountedRef/index.js
// module id = 958
// module chunks = 2